import { render } from "./FontScaleControl.vue?vue&type=template&id=36c6e84f&scoped=true"
import script from "./FontScaleControl.vue?vue&type=script&lang=js"
export * from "./FontScaleControl.vue?vue&type=script&lang=js"

import "./FontScaleControl.vue?vue&type=style&index=0&id=36c6e84f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c6e84f"]])

export default __exports__